"use client";

import { useNavigate } from "react-router-dom";

function AccessDenied() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4">
      <h1 className="text-2xl font-semibold text-gray-900">Access Denied</h1>
      <p className="mt-2 text-gray-600">You do not have permission to access this page.</p>
      <button
        type="button"
        onClick={() => navigate("/dashboard")}
        className="mt-6 rounded-md bg-primary px-4 py-2 text-sm font-medium text-white hover:opacity-90"
      >
        Back to Dashboard
      </button>
    </div>
  );
}

export default AccessDenied;
